import { buildUserKeyPrefix } from './types';

/**
 * Logout integration — removes all persisted filter state for the given user.
 *
 * Plan Section "Persistence key contract":
 *   "On logout, the app is responsible for clearing this user's filter persistence.
 *    The recommended pattern is a `clearAllFilterPersistence(tenantId, userId)` helper
 *    that iterates localStorage keys matching the prefix and removes them."
 *
 * Operates on `window.localStorage` and `window.sessionStorage`. Does not touch URL params
 * (those are page-scoped, not user-scoped).
 */
export function clearAllFilterPersistence(tenantId: string, userId: string): void {
  if (typeof window === 'undefined') return;
  const prefix = buildUserKeyPrefix({ tenantId, userId });
  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      const keys: string[] = [];
      for (let i = 0; i < storage.length; i++) {
        const k = storage.key(i);
        if (k && k.startsWith(prefix)) keys.push(k);
      }
      for (const k of keys) storage.removeItem(k);
    } catch (err) {
      console.warn('[FilterBar persistence] clearAllFilterPersistence failed:', err);
    }
  }
}
